import styled from 'styled-components';

export const List = styled.ul({
  paddingLeft: 40,
  marginBottom: 15,
  listStyle: 'disc',
})
